import { validDateFormat, validTimeFormat } from "../../utils/date_util";
export function eventBlockDateRangeValidator($el) {
  const eventBlock = $el.closest(".event-block")[0];
  const blockStartDateDatepickerContainer = eventBlock.querySelector(".event-block__start-date");
  const blockEndDateDatepickerContainer = eventBlock.querySelector(".event-block__end-date");
  const blockStartDateDatepickerInput = blockStartDateDatepickerContainer.querySelector('input[id*="_at_date"]');
  const blockStartTimepickerInput = blockStartDateDatepickerContainer.querySelector('input[id*="_at_time"]');
  const blockEndDateDatepickerInput = blockEndDateDatepickerContainer.querySelector('input[id*="_at_date"]');
  const blockEndTimepickerInput = blockEndDateDatepickerContainer.querySelector('input[id*="_at_time"]');
  const blockStartDateDatepickerInputValue = blockStartDateDatepickerInput.value;
  const blockStartTimepickerInputValue = blockStartTimepickerInput.value;
  const blockEndDateDatepickerInputValue = blockEndDateDatepickerInput.value;
  const blockEndTimepickerInputValue = blockEndTimepickerInput.value;
  const blockStartDateDatepickerInputValueValidFormat = validDateFormat(blockStartDateDatepickerInputValue);
  const blockEndDateDatepickerInputValueValidFormat = validDateFormat(blockStartDateDatepickerInputValue);
  const blockStartTimepickerInputValueValidFormat = validTimeFormat(blockStartTimepickerInputValue);
  const blockEndTimepickerInputValueValidFormat = validTimeFormat(blockEndTimepickerInputValue);
  if (!blockStartDateDatepickerInputValueValidFormat || !blockEndDateDatepickerInputValueValidFormat || !blockStartTimepickerInputValueValidFormat || !blockEndTimepickerInputValueValidFormat) {
    return true;
  }
  const [startDay, startMonth, startYear] = blockStartDateDatepickerInputValue.split("/");
  const [endDay, endMonth, endYear] = blockEndDateDatepickerInputValue.split("/");
  const [startHours, startMinutes] = blockStartTimepickerInputValue.split(":");
  const [endHours, endMinutes] = blockEndTimepickerInputValue.split(":");
  const blockStartDate = new Date(+startYear, +startMonth, +startDay, +startHours, +startMinutes);
  const blockEndDate = new Date(+endYear, +endMonth, +endDay, +endHours, +endMinutes);
  return blockStartDate < blockEndDate;
}
Foundation.Abide.defaults.validators["event_block_date_range"] = eventBlockDateRangeValidator;
